import React from 'react';
import YFMWrapper from '../../../components/YFMWrapper/YFMWrapper';
import { block } from '../../../utils';
import './PreviewContent.css';
const b = block('preview-content-block');
const PreviewContent = (props) => {
    const { id, title, description = '', switching, onClick, mods } = props;
    return (React.createElement("div", { key: id, className: b('content-wrapper') },
        React.createElement("div", { className: b('content', mods), onClick: onClick },
            React.createElement("div", { className: b('loader-block', Object.assign(Object.assign({}, mods), { auto: switching })) }),
            React.createElement("h2", { className: b('title') }, title),
            description && (React.createElement("div", { className: b('description') },
                React.createElement(YFMWrapper, { content: description, modifiers: { constructor: true } }))))));
};
export default PreviewContent;
